import React from 'react';
import { PropTypes } from 'prop-types';
import { IconMore } from '@wds/icons';
import { Button } from '@wds/button';
import { Menu } from '@wds/menu';

import FilePreviewer from 'sma.common/components/file_previewer';

export default function ActionMenu(props) {
	const handleViewClick = () => {
		const file = {
			url: props.filePath,
			type: 'file',
			name: props.fileName,
		};
		if (props.convertedFilePath) {
			file['converted_url'] = props.convertedFilePath;
		}
		const config = {
			files: [file]
		};

		new FilePreviewer(config);
	};

	const handleDeleteClick = () => {
		props.handleFileDelete(props.index, props.filePath);
	};

	const menuTrigger = (
		<Button
			color="secondary"
			buttonType="button"
			label="more actions"
		>
			<IconMore />
		</Button>
	);

	const menuItems = (
		<>
			{
				props.filePath
				&& (
					<>
						<Menu.Item onClick={handleViewClick}>{gettext('View')}</Menu.Item>
						<Menu.Item
							navigationTarget={props.filePath}
							isNavigable
							download
						>
							{gettext('Download')}
						</Menu.Item>
					</>
				)
			}
			<Menu.Item onClick={handleDeleteClick}>{gettext('Delete')}</Menu.Item>
		</>
	);

	return (
		<>
			<Menu
				autoClose="false"
				dense
				noRules
				menuTrigger={menuTrigger}
			>
				{ menuItems }
			</Menu>
		</>
	);
}

ActionMenu.propTypes = {
	index: PropTypes.number.isRequired,
	mediaUrl: PropTypes.string.isRequired,
	handleFileView: PropTypes.func,
	handleFileDelete: PropTypes.func,
	handleFileDownload: PropTypes.func,
	filePath: PropTypes.string,
	convertedFilePath: PropTypes.string,
	fileName: PropTypes.string,
};
